import script from "./ThouCanvas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThouCanvas.vue?vue&type=script&setup=true&lang=ts"

import "./ThouCanvas.vue?vue&type=style&index=0&id=51fdd694&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51fdd694"]])

export default __exports__